import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { logError } from "../../../utils/utils";
import { cellValueObject, kenngroesse, messstelle } from "../../../utils/apiTypes";
import { trendsTable } from "./trendsTypes"
import { postJsonWithAuth } from "../../../utils/api";
import { errorHandler } from "../../../utils/errorHandling";


const initialState: trendsTable = {
    isLoadingTrendsTable: false,
    kenngroesseHeaderListe: [],
    vertikalSumListe: [],
    horizentalSumListe: [],
    sumAll: 0,
    trendsListe: [],
}

// Slice
const trendsTableSlice = createSlice({
    name: "trendsTable",
    initialState,
    reducers: {
        setIsLoadingTrendsTable: (state, action: PayloadAction<boolean>) => {
            state.isLoadingTrendsTable = action.payload
        },

        setKenngroesseHeaderListe: (state, action: PayloadAction<Array<string>>) => {
            state.kenngroesseHeaderListe = action.payload
        },

        setVertikalSumListe: (state, action: PayloadAction<Array<number>>) => {
            state.vertikalSumListe = action.payload
        },

        setHorizentalSumListe: (state, action: PayloadAction<Array<number>>) => {
            state.horizentalSumListe = action.payload
        },

        setSumAll: (state, action: PayloadAction<number>) => {
            state.sumAll = action.payload
        },
        setTrendsListe: (state, action: PayloadAction<Array<Array<cellValueObject>>>) => {
            state.trendsListe = action.payload
        },
        
    }
})

// Selectors

export const selectIsLoadingTrendsTable = (state: RootState): boolean => state.trendsTable.isLoadingTrendsTable;
export const selectKenngroesseListe = (state: RootState): string[] => state.trendsTable.kenngroesseHeaderListe;
export const selectVertikalSumListe = (state: RootState): number[] => state.trendsTable.vertikalSumListe;
export const selectHorizentalSumListe = (state: RootState): number[] => state.trendsTable.horizentalSumListe;
export const selectSumAll = (state: RootState): number => state.trendsTable.sumAll;
export const selectTrendsListe = (state: RootState): cellValueObject[][] => state.trendsTable.trendsListe;

// Actions

export const {
    setIsLoadingTrendsTable,
    setKenngroesseHeaderListe,
    setVertikalSumListe,
    setHorizentalSumListe,
    setSumAll,
    setTrendsListe

} = trendsTableSlice.actions;

//Getter
export const getTrendsTable = (idParam: number,
    kenngroesseParam: Array<kenngroesse>, 
    messstelleParam: Array<messstelle>,
    currentValueMinParam: number,
    currentValueMaxParam: number,
    increaseMinParam: number,
    increaseMaxParam: number,
    increaseDurationMinParam: number,
    increaseDurationMaxParam: number,
    medianIncreaseMinParam: number,
    medianIncreaseMaxParam: number) => (
    dispatch: AppDispatch, getState: () => RootState): void => {

        const state = getState().trendsFilter;
const body = {
        anfrageId: idParam,
        kenngroessen: kenngroesseParam.map(x => x.feldname),
        messstellen: messstelleParam.map(x => x.name),
        currentValueMin: state.isAktuellerAktiv ? currentValueMinParam : null,
        currentValueMax: state.isAktuellerAktiv ? currentValueMaxParam : null,
        increaseMin: state.isAktuellerAnstiegAktiv ? increaseMinParam : null,
        increaseMax: state.isAktuellerAnstiegAktiv ? increaseMaxParam : null,
        increaseDurationMin: state.isAktuellerAnstiegsdauerAktiv ? increaseDurationMinParam : null,
        increaseDurationMax: state.isAktuellerAnstiegsdauerAktiv ? increaseDurationMaxParam : null,
        medianIncreaseMin: state.isMittlererAnstiegAktiv ? medianIncreaseMinParam : null,
        medianIncreaseMax: state.isMittlererAnstiegAktiv ? medianIncreaseMaxParam : null
    }

    dispatch(setIsLoadingTrendsTable(true))
    postJsonWithAuth("TRENDSTABELLE", {}, body)
        .then((response: Array<Array<cellValueObject>>) => {

            dispatch(setTrendsListe(response));

            const tempKenngroesseList: Array<string> = [];
            const tempSumHorizentalList: Array<number> = [];
            const tempSumVertikalList: Array<number> = [];
            let sumAll = 0;

            response.forEach(rows => {
                let tempSumHorizental = 0;
                rows.forEach(row => {
                    if (row.col != null) {
                        tempKenngroesseList.push(row.col)
                        tempSumHorizental += row.value; 
                        sumAll += row.value;
                    }
                })
                tempSumHorizentalList.push(tempSumHorizental) 
            });
            dispatch(setHorizentalSumListe(tempSumHorizentalList));

            tempKenngroesseList.sort((a, b) => a.localeCompare(b))
            const filteredKenngroesseList: Array<string> = tempKenngroesseList.filter(function (elem, pos) {
                return tempKenngroesseList.indexOf(elem) == pos;
            })

            dispatch(setKenngroesseHeaderListe(filteredKenngroesseList));

            filteredKenngroesseList.forEach((elem) => {
                let sumVertical = 0;
                response.forEach((rows) => {
                    rows.forEach((row) => {
                        if (elem == row.col) {
                            sumVertical += row.value;
                        }
                    })
                })
                tempSumVertikalList.push(sumVertical);
            })
            dispatch(setVertikalSumListe(tempSumVertikalList));
            dispatch(setSumAll(sumAll));

        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setIsLoadingTrendsTable(false)));
    };

export default trendsTableSlice.reducer;
